// @ts-nocheck

import * as SpineAnimationAssets from '../assets/spine/animations';
import { getLang } from '../i18n/l10n';
import { BoomSpineAnimations } from '../modules/boom/constants/animations';
import { MonopolyDeSpineAnimations } from '../modules/monopoly/constants/animationsDe';
import { MonopolyEsSpineAnimations } from '../modules/monopoly/constants/animationsEs';
import { MonopolyFrSpineAnimations } from '../modules/monopoly/constants/animationsFr';
import { GeneralSpineAnimationsIds, SpineAnimationIds } from '../types/animations';

export const SpineAnimations = {
  [GeneralSpineAnimationsIds.WIN_FREEBETS]: [
    {
      assets: SpineAnimationAssets.FreebetsAnimation,
      forwards: true,
    },
  ],
  // #region Opé Koh-Lanta
  [SpineAnimationIds.KL_INTRO]: [
    {
      assets: SpineAnimationAssets.Victory,
      forwards: true,
      animation: SpineAnimationAssets.Victory.animations.INTRO,
      skin: SpineAnimationAssets.Victory.skins.DAY,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_FISHING]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FISHING,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FISHING,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_FISHING]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FISHING,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_FIRECAMP]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FIRECAMP,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FIRECAMP,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_FIRECAMP]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_FIRECAMP,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_HUT]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_HUT,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_HUT,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_HUT]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_HUT,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_RICE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_RICE,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_RICE,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_RICE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_RICE,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_WATER]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_WATER,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_WATER,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_WATER]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_WATER,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_BALANCE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BALANCE,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BALANCE,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_BALANCE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BALANCE,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_GRAND_BLUE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_GRAND_BLUE,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_GRAND_BLUE,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_GRAND_BLUE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_GRAND_BLUE,
    },
  ],

  [SpineAnimationIds.KL_BADGE_WON_DUO]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_DUO,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_DUO,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_DUO]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_DUO,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_SLOTH]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_SLOTH,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_SLOTH,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_SLOTH]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_SLOTH,
    },
  ],
  [SpineAnimationIds.KL_BADGE_WON_BAMBOOS]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BAMBOOS,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BAMBOOS,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_BADGE_LOST_BAMBOOS]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.BADGE_BAMBOOS,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_WON_CHOCOLATE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_CHOCOLATE,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_CHOCOLATE,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_LOST_CHOCOLATE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_CHOCOLATE,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_WON_HOTEL]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_HOTEL,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_HOTEL,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_LOST_HOTEL]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_HOTEL,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_WON_PIZZA]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_WON,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_PIZZA,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_LOOP,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_PIZZA,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_COMFORT_LOST_PIZZA]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.BADGE_FAIL,
      skin: SpineAnimationAssets.KLCollectibles.skins.COMFORT_PIZZA,
    },
  ],
  [SpineAnimationIds.KL_COLLAR_WON]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.COLLAR_WON,
    },
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: false,
      animation: SpineAnimationAssets.KLCollectibles.animations.COLLAR_LOOP,
      loop: true,
    },
  ],
  [SpineAnimationIds.KL_COLLAR_LOST]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.COLLAR_FAIL,
    },
  ],
  [SpineAnimationIds.KL_VICTORY]: [
    {
      assets: SpineAnimationAssets.Victory,
      forwards: true,
      animation: SpineAnimationAssets.Victory.animations.INTRO2,
    },
  ],
  [SpineAnimationIds.KL_VOTE]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.VOTE,
    },
  ],
  [SpineAnimationIds.KL_COLLAR_USED]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.COLLAR_USED,
    },
  ],
  [SpineAnimationIds.KL_TORCH]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ELIMINATION,
    },
  ],
  [SpineAnimationIds.KL_ROUND_COMPLETE]: [
    {
      assets: SpineAnimationAssets.Victory,
      forwards: false,
      animation: SpineAnimationAssets.Victory.animations.TRANSITION,
    },
  ],
  [SpineAnimationIds.KL_MARK_WON_1]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_1_WON,
    },
  ],
  [SpineAnimationIds.KL_MARK_LOST_1]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_1_FAIL,
    },
  ],
  [SpineAnimationIds.KL_MARK_WON_2]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_2_WON,
    },
  ],
  [SpineAnimationIds.KL_MARK_LOST_2]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_2_FAIL,
    },
  ],
  [SpineAnimationIds.KL_MARK_WON_3]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_3_WON,
    },
  ],
  [SpineAnimationIds.KL_MARK_LOST_3]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_MARK_3_FAIL,
    },
  ],
  [SpineAnimationIds.KL_TAG_WON_1]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_1_WON,
    },
  ],
  [SpineAnimationIds.KL_TAG_LOST_1]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_1_FAIL,
    },
  ],
  [SpineAnimationIds.KL_TAG_WON_2]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_2_WON,
    },
  ],
  [SpineAnimationIds.KL_TAG_LOST_2]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_2_FAIL,
    },
  ],
  [SpineAnimationIds.KL_TAG_WON_3]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_3_WON,
    },
  ],
  [SpineAnimationIds.KL_TAG_LOST_3]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_TAG_3_FAIL,
    },
  ],
  [SpineAnimationIds.KL_KNIFE_WON]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_KNIFE_WON,
    },
  ],
  [SpineAnimationIds.KL_KNIFE_LOST]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_KNIFE_FAIL,
    },
  ],
  [SpineAnimationIds.KL_KNIFE_MISS_1]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_KNIFE_MISS_1,
    },
  ],
  [SpineAnimationIds.KL_KNIFE_MISS_2]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_KNIFE_MISS_2,
    },
  ],
  [SpineAnimationIds.KL_KNIFE_MISS_3]: [
    {
      assets: SpineAnimationAssets.KLCollectibles,
      forwards: true,
      animation: SpineAnimationAssets.KLCollectibles.animations.ORIENTATION_KNIFE_MISS_3,
    },
  ],
  [SpineAnimationIds.KL_POLE_BET_WON]: [
    {
      assets: SpineAnimationAssets.KLPastille,
      forwards: true,
      animation: SpineAnimationAssets.KLPastille.animations.PASTILLE,
      skin: SpineAnimationAssets.KLPastille.skins.WIN,
    },
  ],
  [SpineAnimationIds.KL_POLE_BET_LOST]: [
    {
      assets: SpineAnimationAssets.KLPastille,
      forwards: false,
      animation: SpineAnimationAssets.KLPastille.animations.PASTILLE,
      skin: SpineAnimationAssets.KLPastille.skins.LOOSE,
    },
  ],
  // #endregion
  // #region BetBuilder
  [SpineAnimationIds.MY_MATCH]: [
    {
      assets: SpineAnimationAssets.MyMatch,
      forwards: !SpineAnimationAssets.MyMatch.isLoop,
      loop: SpineAnimationAssets.MyMatch.isLoop,
    },
  ],
  // #endregion
  // #region WinModal
  [SpineAnimationIds.WM_BASKET]: [
    {
      assets: SpineAnimationAssets.Basket,
      forwards: !SpineAnimationAssets.Basket.isLoop,
      loop: SpineAnimationAssets.Basket.isLoop,
    },
  ],
  [SpineAnimationIds.WM_BOXEUR]: [
    {
      assets: SpineAnimationAssets.Boxeur,
      forwards: !SpineAnimationAssets.Boxeur.isLoop,
      loop: SpineAnimationAssets.Boxeur.isLoop,
    },
  ],
  [SpineAnimationIds.WM_COSMO]: [
    {
      assets: SpineAnimationAssets.Cosmo,
      forwards: !SpineAnimationAssets.Cosmo.isLoop,
      loop: SpineAnimationAssets.Cosmo.isLoop,
    },
  ],
  [SpineAnimationIds.WM_CROCO]: [
    {
      assets: SpineAnimationAssets.Croco,
      forwards: !SpineAnimationAssets.Croco.isLoop,
      loop: SpineAnimationAssets.Croco.isLoop,
    },
  ],
  [SpineAnimationIds.WM_GENIE]: [
    {
      assets: SpineAnimationAssets.Genie,
      forwards: !SpineAnimationAssets.Genie.isLoop,
      loop: SpineAnimationAssets.Genie.isLoop,
    },
  ],
  [SpineAnimationIds.WM_GORILLE]: [
    {
      assets: SpineAnimationAssets.Gorille,
      forwards: !SpineAnimationAssets.Gorille.isLoop,
      loop: SpineAnimationAssets.Gorille.isLoop,
    },
  ],
  [SpineAnimationIds.WM_HALTEROPHILE]: [
    {
      assets: SpineAnimationAssets.Halterophile,
      forwards: !SpineAnimationAssets.Halterophile.isLoop,
      loop: SpineAnimationAssets.Halterophile.isLoop,
    },
  ],
  [SpineAnimationIds.WM_LION]: [
    {
      assets: SpineAnimationAssets.Lion,
      forwards: !SpineAnimationAssets.Lion.isLoop,
      loop: SpineAnimationAssets.Lion.isLoop,
    },
  ],
  [SpineAnimationIds.WM_SAGE]: [
    {
      assets: SpineAnimationAssets.Sage,
      forwards: !SpineAnimationAssets.Sage.isLoop,
      loop: SpineAnimationAssets.Sage.isLoop,
    },
  ],
  [SpineAnimationIds.WM_SOLDAT]: [
    {
      assets: SpineAnimationAssets.Soldat,
      forwards: !SpineAnimationAssets.Soldat.isLoop,
      loop: SpineAnimationAssets.Soldat.isLoop,
    },
  ],
  [SpineAnimationIds.WM_SUPERMAN]: [
    {
      assets: SpineAnimationAssets.Superman,
      forwards: !SpineAnimationAssets.Superman.isLoop,
      loop: SpineAnimationAssets.Superman.isLoop,
    },
  ],
  // #endregion
  // #region BetShare
  [SpineAnimationIds.BS_WIN]: [
    {
      assets: SpineAnimationAssets.Win,
      forwards: !SpineAnimationAssets.Win.isLoop,
      loop: SpineAnimationAssets.Win.isLoop,
      skin: getLang().toUpperCase(),
    },
  ],
  [SpineAnimationIds.BS_CANCEL]: [
    {
      assets: SpineAnimationAssets.Cancel,
      forwards: !SpineAnimationAssets.Cancel.isLoop,
      loop: SpineAnimationAssets.Cancel.isLoop,
      skin: getLang().toUpperCase(),
    },
  ],
  // #endregion
  // #region Overlay
  [SpineAnimationIds.OL_EAGLE]: [
    {
      assets: SpineAnimationAssets.Aigle,
    },
  ],
  [SpineAnimationIds.OL_ROOSTER]: [
    {
      assets: SpineAnimationAssets.Coq,
    },
  ],
  [SpineAnimationIds.OL_BULL]: [
    {
      assets: SpineAnimationAssets.Taureau,
    },
  ],
  // #endregion

  // #region Gift race
  [SpineAnimationIds.GR_SHOE]: [
    {
      assets: SpineAnimationAssets.Shoe,
      forwards: !SpineAnimationAssets.Shoe.isLoop,
      loop: SpineAnimationAssets.Shoe.isLoop,
    },
  ],
  [SpineAnimationIds.GR_BALLOON]: [
    {
      assets: SpineAnimationAssets.Balloon,
      forwards: !SpineAnimationAssets.Balloon.isLoop,
      loop: SpineAnimationAssets.Balloon.isLoop,
    },
  ],
  [SpineAnimationIds.GR_SHIRT]: [
    {
      assets: SpineAnimationAssets.Shirt,
      forwards: !SpineAnimationAssets.Shirt.isLoop,
      loop: SpineAnimationAssets.Shirt.isLoop,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X1]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X2]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X5]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X5,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X10]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X10,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X20]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X20,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_FR]: [
    {
      assets: SpineAnimationAssets.GRStartFR,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_EN]: [
    {
      assets: SpineAnimationAssets.GRStartEN,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_ES]: [
    {
      assets: SpineAnimationAssets.GRStartES,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_DE]: [
    {
      assets: SpineAnimationAssets.GRStartDE,
      forwards: true,
    },
  ],
  // #endregion

  // #region Monopoly
  ...MonopolyFrSpineAnimations,
  ...MonopolyEsSpineAnimations,
  ...MonopolyDeSpineAnimations,
  // #endregion

  // #region Boom
  ...BoomSpineAnimations,
  // #endregion
};
